class AccordionItems {
  constructor(el) {
    this.el = el;
    this.elItems = this.el.querySelectorAll(".accordion__item");
    this.eldesc = this.el.querySelector(".accordion__body-description");

    for (let item of this.elItems) {
      new AccordionItem(item, this);
    }

    window.addEventListener('resize', () => {
      this.handleResize();
    });
  }

  
  closeOtherItems(currentItemInstance) {
    this.elItems.forEach((item) => {
      if (item !== currentItemInstance.el && item.classList.contains("expanded")) {
        
        const button = item.querySelector(".accordion__item-button");
        const panel = item.querySelector(".accordion__item-panel");
  
        button.setAttribute("aria-expanded", false);
        panel.style.height = "0px";
        panel.style.opacity = "0";
        item.classList.remove("expanded");
  
        const bodyContent = item.querySelector('.accordion__body-content');
        if (bodyContent) {
          bodyContent.style.height = 'auto';
          bodyContent.style.minHeight = '';
        }
        checkOverlap('.accordion__body-description', '.accordion__item-image', true);
        //checkOverflow('.accordion__body-content', '.accordion__item-image', true);
      }
    });
  }
  

  handleResize() {
    checkOverlap('.accordion__body-description', '.accordion__item-image');
    //checkOverflow('.accordion__body-content', '.accordion__item-image');
  }
}

class AccordionItem {
  constructor(el, accordion) {
    this.el = el;
    this.accordion = accordion;
    this.elButton = this.el.querySelector(".accordion__item-button");
    this.elPanel = this.el.querySelector(".accordion__item-panel");

    this.elButton.addEventListener(
      "click",
      function () {
        const accordionExpanded = this.elButton.getAttribute("aria-expanded") === "true";
        if (!accordionExpanded) {
          this.accordion.closeOtherItems(this.el);

          this.elButton.setAttribute("aria-expanded", true);
          this.elPanel.style.height = this.elPanel.scrollHeight + "px";
          this.elPanel.style.transition =
            "height .1s ease-in-out, opacity .5s ease-in-out .2s, margin-top .25s ease-in-out";
          this.elPanel.style.opacity = "1";
          this.el.classList.add("expanded");

          //checkOverflow('.accordion__body-content', '.accordion__item-image');
          checkOverlap('.accordion__body-description', '.accordion__item-image');
          
          const bodyContent = this.el.querySelector('.accordion__body-content');
          if (bodyContent) {
            bodyContent.style.height = 'auto';
            bodyContent.style.minHeight = '';
          }
        } else {
          this.elButton.setAttribute("aria-expanded", false);
          this.elPanel.style.transition =
            "height .25s ease-in-out, opacity .25s ease-in-out .2s, margin-top .25s ease-in-out .1s";
          this.elPanel.style.height = "0px";
          this.elPanel.style.opacity = "0";
          this.el.classList.remove("expanded");

          const bodyContent = this.el.querySelector('.accordion__body-content');
          if (bodyContent) {
            bodyContent.style.height = 'auto';
            bodyContent.style.minHeight = '';
          }
          // Restablecer los estilos al cerrarse
          checkOverlap('.accordion__body-description', '.accordion__item-image', true);
          //checkOverflow('.accordion__body-content', '.accordion__item-image', true);
        }
        const parent = this.el.closest('.js-accordion')
        if(parent && !parent.classList.contains('solutions')) {
          console.log('scroll');
          setTimeout(() => {
            const offset = 150;
            const y = this.el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }, 150);
        }
      }.bind(this),
      false
    );
  }
}

/*
function checkOverflow(accordSelector, imgSelector, reset = false) {
  const accord = document.querySelector(accordSelector);

  //console.log(accord);
  if (!accord) return;

  if (!reset && !document.querySelector('.accordion__item.expanded')) return;

  const accordRect = accord.getBoundingClientRect();
  document.querySelectorAll(imgSelector).forEach(imgEl => {
    if (reset) {
      accord.style.minHeight = '';
      return;
    }

    const imgRect = imgEl.getBoundingClientRect();
    const sectionOverlap = imgRect.bottom > accordRect.bottom;
    //console.log("imgRect.bottom:");
    //console.log(imgRect.bottom);
    //console.log("accordRect.bottom:");
    //console.log(accordRect.bottom);



    if (sectionOverlap) {
      //console.log("test");
      const difference = imgRect.bottom - accordRect.bottom;
      accord.style.minHeight = `${accord.offsetHeight + difference}px`;
    }
  });
}
*/


function checkOverlap(descSelector, imgSelector, reset = false) {
  const desc = document.querySelector(descSelector);
  if (!desc) return;

  const isDefaultAccordion = desc.closest('.accordion--default');
  if (!isDefaultAccordion) return;

  if (!reset && !document.querySelector('.accordion__item.expanded')) return;

  //const descRect = desc.getBoundingClientRect();

  /* document.querySelectorAll(imgSelector).forEach(imgEl => {
    if (reset) {
      imgEl.style.top = '';
      return;
    }

    const imgRect = imgEl.getBoundingClientRect();
    
    if (imgRect.top < descRect.bottom) {
      const offset = descRect.bottom - imgRect.top + 80;
      imgEl.style.top = `${offset}px`;
    }
  }); */
}

const initAccordions = () => {
  const accordions = document.querySelectorAll(".js-accordion");

  if (accordions) {
    for (let accordion of accordions) {
      new AccordionItems(accordion);
    }
  }
};

initAccordions();

class accordionAnalytics {
  el;
  eventName; 

  constructor(el, eventName) {
    this.el = el;
    this.eventName = eventName;
    
    this.bindListeners();
  }

  bindListeners() {
    this.el.addEventListener("click", this.dataPush.bind(this));
  }

  dataPush() {
    const itemName = this.el.querySelector('.accordion__item-title').textContent.trim();
    const evento = {
      event: 'click_' + this.eventName,
      item_nombre: itemName
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
    //console.log('Evento enviado al dataLayer:', evento);
  }
}

const initAnalyticsAccordion = () => {  
  const accordionAnalyze = document.querySelectorAll('section.accordion.solutions, section.accordion.sectors');
  accordionAnalyze?.forEach((accordion) => {
    const items = accordion.querySelectorAll('button.accordion__item-button');
    items?.forEach((item) => {
      if(accordion.classList.contains('solutions')) {
        new accordionAnalytics(item, 'soluciones');
      }else if(accordion.classList.contains('sectors')) {
        new accordionAnalytics(item, 'sectores');
      }
    })
  });
}

initAnalyticsAccordion();